import { createAction } from '@reduxjs/toolkit';

export const METRICS_FETCH_DATA_INIT = createAction('METRICS_FETCH_DATA_INIT');
export const METRICS_FETCH_DATA_SUCCESS = createAction(
  'METRICS_FETCH_DATA_SUCCESS'
);
export const METRICS_FETCH_DATA_FAIL = createAction('METRICS_FETCH_DATA_FAIL');
